"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var TypographyTheme = function TypographyTheme(colors, breakpoints) {
  return {
    styleOverrides: {
      root: {
        color: colors.ultramarine,
        fontSize: 14
      },
      h1: (0, _defineProperty2["default"])({
        fontFamily: 'Montserrat',
        fontSize: '1.5rem',
        fontWeight: 700,
        lineHeight: '32px',
        letterSpacing: '0.01em'
      }, breakpoints.down('xs'), {
        fontSize: '1.5rem',
        lineHeight: 1.2,
        letterSpacing: 0
      }),
      h2: (0, _defineProperty2["default"])({
        fontFamily: 'Montserrat',
        fontSize: '1.25rem',
        fontWeight: 700,
        letterSpacing: '0.01em',
        lineHeight: '28px'
      }, breakpoints.down('xs'), {
        fontSize: '1.375rem',
        lineHeight: 1.22,
        letterSpacing: 0
      }),
      h3: (0, _defineProperty2["default"])({
        fontFamily: 'Montserrat',
        fontSize: '1.125rem',
        letterSpacing: '0.01em',
        fontWeight: 700,
        lineHeight: '24px'
      }, breakpoints.down('xs'), {
        fontSize: '1.125rem',
        lineHeight: 1.2,
        letterSpacing: 0
      }),
      h4: (0, _defineProperty2["default"])({
        fontFamily: 'Montserrat',
        fontSize: '1rem',
        lineHeight: '20px',
        letterSpacing: '0.01em',
        fontWeight: 600
      }, breakpoints.down('xs'), {
        letterSpacing: 0
      }),
      h5: (0, _defineProperty2["default"])({
        fontFamily: 'Montserrat',
        fontSize: '0.875rem',
        letterSpacing: '0.01em',
        lineHeight: '16px',
        fontWeight: 600
      }, breakpoints.down('xs'), {
        lineHeight: 1.2,
        letterSpacing: 0
      }),
      subtitle1: {
        fontFamily: 'Barlow',
        fontSize: '1rem',
        lineHeight: '20px',
        letterSpacing: 0,
        fontWeight: 500
      },
      subtitle2: {
        fontFamily: 'Barlow',
        fontSize: '0.875rem',
        lineHeight: '16px',
        letterSpacing: 0,
        fontWeight: 500
      },
      body1: {
        fontFamily: 'Barlow',
        fontSize: '1rem',
        lineHeight: '20px',
        letterSpacing: '0.01em',
        fontWeight: 400
      },
      body2: {
        fontFamily: 'Barlow',
        fontSize: '0.875rem',
        lineHeight: '20px',
        letterSpacing: '0.01em',
        fontWeight: 400
      },
      caption: {
        fontFamily: 'Barlow',
        fontStyle: 'italic',
        fontSize: '0.75rem',
        lineHeight: '16px',
        letterSpacing: '0.01em'
      }
    },
    variants: [{
      props: {
        variant: 'body3'
      },
      style: {
        fontFamily: 'Barlow',
        fontSize: '0.75rem',
        lineHeight: '16px',
        letterSpacing: '0.01em',
        fontWeight: 400
      }
    }, {
      props: {
        variant: 'mini'
      },
      style: {
        fontFamily: 'Montserrat',
        fontSize: '0.625rem',
        lineHeight: '16px',
        letterSpacing: 0,
        fontWeight: 600
      }
    }]
  };
};

var _default = TypographyTheme;
exports["default"] = _default;